import React from 'react';
import rg4js from 'raygun4js';
import { hotjar } from 'react-hotjar';

import GameStore from '../store';
import AudioWaves from './audioWaves/AudioWaves';

import iPhone from '../assets/images/iPhone.png';
import background from '../assets/images/vishing_bg.jpg';
import '../assets/styles/index.scss';
import './styles/Home.scss';

/* global Audio, alert */

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.subdomain = window.location.hostname.split('.')[0];
    const gameId = this.getSubdomainParam();
    this.gameStore = new GameStore();

    this.state = this.defaultState(gameId);

    rg4js('apiKey', 'Jc6lCwmwDcjImFHm5r5zA');
    rg4js('enableCrashReporting', true);
    rg4js('enablePulse', true);

    hotjar.initialize(1470311, 6);
  }

  componentDidMount() {
    const ringerAudio = this.state.data.ringer && this.state.data.ringer.audio;

    if (ringerAudio) {
      // Pre-loading audio files so they're cached when we need them
      const ringer = new Audio();
      ringer.addEventListener(
        'canplaythrough',
        () => {
          this.setState({ loaded: true });
        },
        false,
      );
      ringer.src = this.state.data.ringer.audio;
    }

    const clips = [];
    this.state.data.audio.forEach(item => {
      const clip = new Audio();
      clip.src = item;
      clips.push(clip);
    });

    window.addEventListener('modal', this.launchModal);
  }

  componentDidCatch(error, info) {
    console.error(error);
    console.log(info);
  }

  componentWillUnmount() {
    window.removeEventListener('modal', this.launchModal);
  }

  defaultState = gameId => {
    const data = this.gameStore.getDataByGameId(parseInt(gameId));

    return {
      gameId,
      data,
      state: 'MODAL',
      step: 0,
      modalData: data && data.instructions,
      helpData: data && data.help,
      helpModalOpen: false,
    };
  };

  launchModal = (e = {}) => {
    this.setState({ state: 'MODAL', modalData: e.detail.instructions, step: 0 });
  };

  getQueryParam(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  getSubdomainParam = () => {
    switch (this.subdomain) {
      case 'vishing':
        return '2';

      case 'coworkertogether':
        return '1';

      default:
    }
  };

  updateStep = nextGame => {
    if (nextGame) {
      this.setState(this.defaultState(nextGame));
    } else {
      this.setState({ step: this.state.step + 1 });
    }
  };

  copyPasscode = text => {
    const modal = document.getElementById('start-modal');
    const textArea = document.createElement('textarea');
    textArea.style.height = '0';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Oops, unable to copy');
    }

    alert('Copied');

    modal.parentNode.removeChild(modal);
    document.body.removeChild(textArea);
  };

  toggleHelpModal = () => {
    this.setState({
      helpModalOpen: !this.state.helpModalOpen,
    });
  };

  getModal = (modalData, step) => {
    const content = modalData[step];

    if (content) {
      return (
        <>
          <div className='modal-backdrop' />
          <div id='start-modal'>
            {content.title && <div id='host-title'>{content.title}</div>}
            <div id='host-text' className={`${content.copy && 'passcode'}`}>
              {content.text}
            </div>
            {content.demo && <img src={content.demo} alt='gameplay example animation' />}
            {content.caption && <div className='caption'>{content.caption}</div>}
            {content.options && (
              <div className='modal-button' onClick={this.updateStep.bind(this, content.gameId)}>
                {content.options[0]}
              </div>
            )}
            {content.copy && (
              <div className='copy-btn' onClick={this.copyPasscode.bind(this, content.text)}>
                Click to Copy
              </div>
            )}
          </div>
        </>
      );
    } else {
      this.setState({ state: 'PLAYING', step: 0 });
    }
  };

  render() {
    const { data, modalData, state, step, helpData, gameId } = this.state;

    return (
      <div id='social-engineering' style={{ backgroundImage: this.state.gameId === '1' ? null : `url(${background})` }}>
        {state === 'MODAL' && this.getModal(modalData, step)}
        {gameId === '1' && this.state.helpModalOpen ? (
          <>
            <div className='modal-backdrop' />
            <div id='start-modal'>
              <div id='host-text'>{helpData.text}</div>
              <div className='modal-button' onClick={this.toggleHelpModal}>
                Close
              </div>
            </div>
          </>
        ) : null}
        {gameId === '1' && (
          <div className='help-modal' onClick={this.toggleHelpModal}>
            <i className='far fa-question-circle fa-2x'></i>
          </div>
        )}
        <div id='phone-container'>
          <img src={iPhone} id='phone-bg' alt='iPhone' />
          <div id='phone-inner'>{state === 'PLAYING' && <AudioWaves data={data} />}</div>
        </div>
      </div>
    );
  }
}
